// Utils
import solver from 'utilities';
import { navigation } from './navigation.js';
import { blockBanner } from './block-banner.js';
import { clientReviews } from './block-client-reviews.js';

window.onload = async function () {
	console.log('--Initializing Scripts');
	window.Solver = {};

	// solver.frontend.mockFetch()
	navigation();
	blockBanner();
	clientReviews();

	console.log('--Scripts Loaded');
};
